"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginForm = void 0;
/* eslint-disable @typescript-eslint/no-floating-promises */
var react_1 = __importStar(require("react"));
var react_toastify_1 = require("react-toastify");
var formik_1 = require("formik");
var constants_1 = require("@app/shared/constants");
var YellowButton_1 = require("@app/components/controls/YellowButton");
var utils_1 = require("@server/shared/utils");
require("./LoginForm.scss");
var initialState = {
    step: 'email'
};
var LoginForm = /** @class */ (function (_super) {
    __extends(LoginForm, _super);
    function LoginForm(props) {
        var _this = _super.call(this, props) || this;
        _this.state = initialState;
        _this.validateEmail = function () {
            if (!_this.props.values.email || !_this.props.values.email.trim().length) {
                return 'Please enter your email address';
            }
            else {
                if (_this.props.values.email.trim().includes('@')) {
                    if (!utils_1.isEmail(_this.props.values.email.trim())) {
                        return 'Please enter your email address';
                    }
                }
                var isInternal = _this.props.onValidateUser(_this.props.values.email);
                if (isInternal) {
                    _this.setState({ step: 'email' });
                }
            }
        };
        _this.validatePassword = function () {
            if (_this.state.step === 'password' && !_this.props.values.password) {
                return 'Please enter your password';
            }
        };
        _this.handleFormKeyPress = function (event) {
            if (react_toastify_1.toast.isActive(constants_1.LOGIN_ERROR_TOAST_ID)) {
                react_toastify_1.toast.dismiss(constants_1.LOGIN_ERROR_TOAST_ID);
            }
            if (event.charCode === constants_1.KEY_ENTER) {
                event.preventDefault();
                _this.props.validateForm().then(function () { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, this.handleContinue()];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                }); });
            }
        };
        _this.handleContinue = function () {
            if (react_toastify_1.toast.isActive(constants_1.LOGIN_ERROR_TOAST_ID)) {
                react_toastify_1.toast.dismiss(constants_1.LOGIN_ERROR_TOAST_ID);
            }
            if (_this.state.step === 'email' && !_this.props.errors.email) {
                var isInternal = _this.props.onValidateUser(_this.props.values.email);
                if (isInternal) {
                    _this.saveUserName();
                    return _this.props.submitForm();
                }
                else {
                    _this.setState({ step: 'password' });
                    setTimeout(function () {
                        _this.props.setSubmitting(false);
                        _this.props.resetForm({ values: {
                                email: _this.props.values.email,
                                password: '',
                                rememberUserName: _this.props.values.rememberUserName
                            }
                        });
                        _this.props.setFieldTouched('password', false, false);
                    }, 0);
                    // Introduce artificial delay before focusing on the textbox
                    // to circumvent found brought up in Safari
                    setTimeout(function () {
                        _this.passwordInput.current.focus();
                    }, 100);
                }
            }
            else {
                _this.saveUserName();
                _this.props.submitForm();
            }
        };
        _this.handleForgotPassword = function () {
            _this.props.onForgotPassword(_this.props.values.email);
        };
        _this.handleRememberance = function () {
            _this.props.setFieldValue('rememberUserName', !_this.props.values.rememberUserName);
        };
        _this.saveUserName = function () {
            // write email into local storage
            if (_this.props.values.rememberUserName) {
                localStorage.setItem(constants_1.BLAST_REMEMBER_USER_KEY, _this.props.values.email);
            }
            else {
                localStorage.removeItem(constants_1.BLAST_REMEMBER_USER_KEY);
            }
        };
        _this.passwordInput = react_1.default.createRef();
        return _this;
    }
    LoginForm.prototype.componentDidMount = function () {
        if (this.props.savedUserName && !this.props.fromLogout) {
            this.handleContinue();
        }
    };
    LoginForm.prototype.render = function () {
        var _a = this.props, errors = _a.errors, touched = _a.touched, values = _a.values;
        return (react_1.default.createElement(formik_1.Form, { id: 'login-form', onKeyPress: this.handleFormKeyPress },
            react_1.default.createElement("div", { className: "field" },
                react_1.default.createElement("label", { className: "label" }, "Sign in with your e-mail address"),
                react_1.default.createElement("div", { className: "control" },
                    react_1.default.createElement(formik_1.Field, { name: "email", type: "text", className: "input", autoFocus: true, validate: this.validateEmail })),
                touched.email && errors.email &&
                    react_1.default.createElement("p", { className: "help is-danger" }, errors.email)),
            react_1.default.createElement("div", { className: "field download-notification-lookup-field", onClick: this.handleRememberance },
                react_1.default.createElement(formik_1.Field, { component: "input", type: "checkbox", className: "is-checkradio is-info", name: "rememberUserName", checked: values.rememberUserName }),
                react_1.default.createElement("label", { className: "label" }, "Remember Me")),
            this.state.step === 'password' &&
                react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("div", { id: 'password', className: "field" },
                        react_1.default.createElement("label", { className: "label" }, "Password"),
                        react_1.default.createElement("p", { className: "is-size-6 forgot-password" },
                            react_1.default.createElement("a", { onClick: this.handleForgotPassword }, "Forgot password?")),
                        react_1.default.createElement("div", { className: "control" },
                            react_1.default.createElement(formik_1.Field, { innerRef: this.passwordInput, name: "password", type: "password", className: "input", validate: this.validatePassword })),
                        react_1.default.createElement("p", { className: "help is-danger" }, touched.password && errors.password ?
                            'Please enter a password' : react_1.default.createElement(react_1.default.Fragment, null, "\u00A0")))),
            react_1.default.createElement("div", { className: "field" },
                react_1.default.createElement("div", { className: "control" },
                    this.state.step === 'email' &&
                        react_1.default.createElement(YellowButton_1.YellowButton, { type: "button", "data-test": "continue-button", isFullWidth: true, className: "button-large", onClick: this.handleContinue }, "Continue"),
                    this.state.step === 'password' &&
                        react_1.default.createElement(YellowButton_1.YellowButton, { type: "submit", "data-test": "continue-button", isFullWidth: true, className: "button-large", onClick: this.handleContinue }, "Login")))));
    };
    return LoginForm;
}(react_1.Component));
exports.LoginForm = LoginForm;
exports.default = formik_1.withFormik({
    mapPropsToValues: function (props) {
        return {
            email: props.savedUserName,
            password: '',
            rememberUserName: props.savedUserName ? true : false
        };
    },
    handleSubmit: function (values, bag) {
        bag.props.onLogin(values.email, values.password);
        bag.resetForm({ values: { email: values.email, password: '', rememberUserName: values.rememberUserName } });
    }
})(LoginForm);
